import React from "react";
import { Field, getIn } from "formik";
import { Input } from "../../native";

/* export default props => (
  <Field
    name={props.name}
    render={({ field, form: { touched, errors } }) => {
      const error = errors[field.name] || getIn(errors, field.name);
      const isDirty = touched[field.name] || getIn(touched, field.name);
      return <Input error={isDirty && error} {...field} {...props} />;
    }}
  />
);
*/

const FormikInput = props => (
  <Field
    name={props.name}
    render={({ field, form: { touched, errors } }) => {
      const error = errors[field.name] || getIn(errors, field.name);
      const isDirty = touched[field.name] || getIn(touched, field.name);
      return <Input error={isDirty && error} {...field} {...props} />;
    }}
  />
);

FormikInput.PhoneInput = props => (
  <Field
    name={props.name}
    render={({ field, form: { touched, errors, values, setValues } }) => {
      const error = errors[field.name] || getIn(errors, field.name);
      const isDirty = touched[field.name] || getIn(touched, field.name);
      return (
        <Input.PhoneInput
          error={isDirty && error}
          {...field}
          {...props}
          onBlur={() => void 0}
          onChange={number => {
            setValues({
              ...values,
              [field.name]: number
            });
          }}
        />
      );
    }}
  />
);

export default FormikInput;



// WEBPACK FOOTER //
// ./src/components/generic/form/formik/Input/index.js